import React from "react";
import { Popover } from "antd";
import { PopoverProps } from "antd/lib/popover";

const DisplayPopover = (props: PopoverProps) => {
  return <Popover {...props}>{props.children}</Popover>;
};

export default DisplayPopover;
